<template>
  <div style="position: absolute;right: 20px;"
    :style="{ top: `${top}px`}"
    v-if="config && config.categories && config.categories.length > 0"
  >
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      dark
      elevation="0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="white"
          v-bind="attrs"
          v-on="on"
          style="color:gray;"
        >
          <v-icon color="gray" small style="margin-right: 5px;color:gray">
            {{getCategoryIcon(selectedCategoryID)}}
          </v-icon><span style="color:gray:padding-left:5px;"> {{getCategoryName(selectedCategoryID, locale)}}</span>
        </v-btn>
      </template>

      <v-card
        style="opacity: 0.8;"
      >
        <v-list>
          <v-list-item
            v-for="(item, index) of config.categories"
            :key="index"
            @click="handleSelectCategory(item.ID)"
            style="border-bottom: 1px solid #CCCCCC80;"
          >
            <v-list-item-title><v-icon small v-if="item.Icon && item.Icon.length > 0" style="margin-top:-5px;margin-right: 10px">{{item.Icon}}</v-icon>{{ getTranslation(item.Name, locale)}}</v-list-item-title>
          <v-divider/>
          </v-list-item>
        </v-list>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            @click="menu = false"
          >
            {{ $t('common.close', locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import utilsService from '@/services/utils'
export default {
  props: {
    top: {
      type: Number,
      default: null,
    },
    config: {
      type: Object,
      requried: true,
    },
    locale: {
      type: String,
      requried: true,
    },
    selectedCategoryID: {
      type: String,
      default: null,
    },
    onSelectCategory: {
      type: Function,
      required: true
    },
  },
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
  }),
  mounted () {
  },
  methods: {
    getCategoryIcon(v) {
      const aux = this.config.categories.filter(x => x.ID === v)[0]
      return aux.Icon && aux.Icon.length > 0 ? aux.Icon : 'mdi-folder'
    },
    getCategoryName(v, locale) {
      const aux = this.config.categories.filter(x => x.ID === v)[0]
      return utilsService.getTranslation(aux.Name, locale)
    },
    getTranslation (v, locale) {
      return utilsService.getTranslation(v, locale)
    },
    handleSelectCategory (v) {
      this.menu = false
      this.onSelectCategory(v)
    },
  },
}
</script>
<style scoped>
.v-menu__content {
  margin-left: 10px;
}
</style>

